module.exports = __webpack_public_path__ + "img/stage_drachenkopf.10c3ba71.jpg";